import { createContext, Dispatch, SetStateAction } from 'react';
import { Issue } from '../../../constants';

export const HomeContext = createContext<HomeContextProps>({
	isLoading: true,
	issues: [],
	search: '',
	setSearch: () => {},
	sortBy: 'date-desc',
	setSortBy: () => {},
});

interface HomeContextProps {
	isLoading: boolean;
	issues: Array<Issue>;
	search: string;
	setSearch: Dispatch<SetStateAction<string>>;
	sortBy: SortType;
	setSortBy: Dispatch<SetStateAction<SortType>>;
	onClickLogOut?: () => void;
}

export type SortType = 'alpha-asc' | 'alpha-desc' | 'date-asc' | 'date-desc';
